import { Button, ModalWindow, TooltipDesktop, Wait16 } from '@cian/ui-kit';
import React, { useState } from 'react';

import { ControlWrapper } from '../../../../components/ControlWrapper';
import { ComplaintFormContainerLoadable } from '../../ComplaintFormContainer';

export function ComplainControlContainer() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <ControlWrapper>
        <TooltipDesktop theme="black" placement="left" title="Пожаловаться">
          <Button
            data-mark="ComplainControl"
            theme="stroke_secondary"
            onClick={() => setOpen(true)}
            size="XS"
            beforeIcon={<Wait16 />}
          />
        </TooltipDesktop>
      </ControlWrapper>
      <ModalWindow
        size="XS"
        width={600}
        fixed={false}
        open={open}
        onClose={() => setOpen(false)}
        content={<ComplaintFormContainerLoadable onClose={() => setOpen(false)} />}
      />
    </>
  );
}
